
import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { LigneFinancement } from "src/app/parametrage/core/model/ligneFinancement/ligneFinancement";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LigneFinancementService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement.service';

@Component({
  selector: "app-edit-ligne-financement",
  templateUrl: "./edit-ligne-financement.component.html",
  styleUrls: ["./edit-ligne-financement.component.scss"]
})
export class EditLigneFinancementComponent implements OnInit {
  dateDebut: any;
  dateFin: any;

  ligneFinancement: LigneFinancement;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementService: LigneFinancementService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {}

  createForm(ligneFinancement: LigneFinancement) {
    this.form2 = this.fb.group({
      code: [ligneFinancement.code, Validators.compose([Validators.required])],
      libelle: [
        ligneFinancement.libelle,
        Validators.compose([Validators.required])
      ],
      montant: [
        ligneFinancement.montant,
        Validators.compose([Validators.required])
      ],
      dateDebut: [
        ligneFinancement.dateDebut,
        Validators.compose([Validators.required])
      ],
      dateFin: [
        ligneFinancement.dateFin,
        Validators.compose([Validators.required])
      ]
    });
  }

  ngOnInit() {
    this.createForm(this.ligneFinancement);
  }

  save(): void {
    this.pressButton = true;
    const id = this.ligneFinancement.id;
    this.ligneFinancement = this.form2.value;
    this.ligneFinancement.id = id;

    if (this.dateDebut) {
      const formattedDate = `${this.dateDebut.year}-${String(
        this.dateDebut.month
      ).padStart(2, "0")}-${String(this.dateDebut.day).padStart(2, "0")}`;
      this.ligneFinancement.dateDebut = formattedDate;
    }

    if (this.dateFin) {
      const formattedDate2 = `${this.dateFin.year}-${String(
        this.dateFin.month
      ).padStart(2, "0")}-${String(this.dateFin.day).padStart(2, "0")}`;
      this.ligneFinancement.dateFin = formattedDate2;
    }

    this._ligneFinancementService
      .update(this.ligneFinancement)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close(this.ligneFinancement);
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
